"use strict";import{IconCheckmark75 as e}from"../src/elements/IconCheckmark75.js";import{defineElement as c}from"@spectrum-web-components/base/src/define-element.js";c("sp-icon-checkmark75",e);
//# sourceMappingURL=sp-icon-checkmark75.js.map
